import ButtonComp from "./ButtonComp";
import ReactHtmlParser from "react-html-parser";

const CtaBanner = ({
  title,
  highlight,
  buttonText,
  onClick,
  rightImage,
  btnText,
  subTitle,
  bgGradient = "radial-gradient(circle at center, rgba(127, 86, 217, 0.88) 0%, transparent 60%),linear-gradient(90deg, rgb(11, 15, 58), rgb(11, 15, 58))",
}) => {
  return (
    <section className="cta-banner py-5">
      <div className="custom-container">
        <div
          className="cta-wrapper cta-wrapper-card position-relative align-content-center"
          style={{ background: bgGradient }}
        >
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-lg-5 text-white p-0 p-lg-4 py-lg-5 px-lg-1">
              <h3 className="top-section-text fw-600 mb-4">
                {title} <br />
                <span className="text-success fw-600">{highlight}</span>
              </h3>

              {/* <button className="primary-btn" onClick={onClick}>
                {buttonText}<img
                    src={`/images/web-new-images/right-arrow.svg`}
                    alt="Register Now"
                  />
              </button> */}
              {
                subTitle && (
                   <p className="plus-sans FS16FW500 mt-3 mb-5">
                 {/* {ReactHtmlParser(subTitle)} */}
                 {subTitle}
                  </p>
                )
              }

            <div className="d-flex flex-lg-row flex-column align-items-center gap-2">
               <ButtonComp link={onClick} btnText={buttonText}  img="/images/web-new-images/new-dark-arrow.svg"/>
               {
                btnText && (
                  <ButtonComp className={"borderGreen"} btnText={btnText} img="/images/web-new-images/new-green-arrow.png"/>
                )
              }
            </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-7 text-center position-relative">
              <img
                src={rightImage}
                alt="banner visual"
                className="cta-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;